import dayjs from 'dayjs';

export const dateFormatter = (date: any) => {
  if (!date) return '-';

  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};
